import { useGetHttp } from "../../http.hook";

export interface ICampaignMetricsEmphemeral {
  budgetUsed: number;
  approvedPosts: number;
  totalPosts: number;
  rejectedPosts: number;
  totalViews: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  costPerView: number;
  totalBudget: number;
  postsPerDay: Array<{ [date: string]: number }>;
  totalViewsChart: Array<{ [date: string]: number }>;
  averageViewsPerPost: number;
  averageLikesPerPost: number;
  averageCommentsPerPost: number;
  averageSharesPerPost: number;
  lastUpdatedAt: Date | null;
}

interface IResponse {
  metrics: ICampaignMetricsEmphemeral;
}

export function useGetCampaignMetricsEmphemeralHttp() {
  return useGetHttp<IResponse>({
    path: "/ephemeral/brand-dash/campaigns/:id/metrics",
  });
}
